/** 历史 PM 空版本等同旧协议；SELF 不由此推断为 PM。 */
export function resolvePmTradeProtocol(market) {
  const source = String(market?.liquiditySource ?? market?.liquidity_source ?? '')
    .trim()
    .toUpperCase();
  if (source === 'SELF') return '';
  const version = String(market?.pmProtocolVersion ?? '')
    .trim()
    .toUpperCase();
  return version || (source === 'PM' ? 'V1' : '');
}
